import { render, staticRenderFns } from "./ResourceItemView.vue?vue&type=template&id=7948207a&"
import script from "./ResourceItemView.vue?vue&type=script&lang=ts&"
export * from "./ResourceItemView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports